<div class="data-page working-area">
    <div class="row">
        <div class="col-8">
            <kendo-grid [kendoGridBinding]="gridData" [pageSize]="25" [pageable]="true" [sortable]="true" [resizable]="true" [filterable]="true" [rowClass]="gridCallback" [selectable]="selectableSettings" (cellClick)="cellClickHandler($event)">            
                <kendo-grid-column field="id" title="ID" [width]="50" [filterable]="false"></kendo-grid-column>
                <kendo-grid-column field="title" title="Title"></kendo-grid-column>
                <kendo-grid-column field="airDate" title="Date & Time" [width]="250">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.airDate | date: (dataItem.isLive ? 'MM/dd/yyyy hh:mm' : 'MM/dd/yyyy')}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="isLive" title="Live" [width]="100" [filterable]="false">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="live-col">{{dataItem.isLive ? "Yes" : "No"}}</span>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </div>
        <div class="col-4">
            <div class="card" id="entityEditForm" *ngIf="activeWebinar">
                <div class="card-header">Edit Webinar</div>
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <mat-checkbox [(ngModel)]="activeWebinar.isLive">Live</mat-checkbox>
                        </div>
                        <div class="col" style="text-align: right;">
                            <mat-checkbox [(ngModel)]="activeWebinar.isActive">Active</mat-checkbox>
                        </div>
                    </div>
                    <mat-form-field>
                        <mat-label>Title</mat-label>
                        <textarea matInput rows="2" style="line-height: 2em;" [(ngModel)]="activeWebinar.title" required></textarea>
                        <mat-error [hidden]="this.valid">Title is required</mat-error>
                    </mat-form-field>



                    <div class="row">
                        <div class="col">
                            <mat-form-field>
                                <mat-label>Choose Air Date</mat-label>
                                <input matInput [matDatepicker]="picker" [(ngModel)]="activeWebinar.airDate" required>
                                <mat-error [hidden]="this.valid">Air Date is required</mat-error>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col">
                            <mat-form-field>
                                <mat-label>Choose Air Time</mat-label>
                                <mat-select [(ngModel)]="activeWebinar.airTime" required>
                                    <mat-option *ngFor="let time of timeList" [value]="time.value">
                                        {{time.name}}
                                    </mat-option>
                                </mat-select>
                                <mat-error [hidden]="this.valid">Air Time is required</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col">
                            <mat-form-field>
                                <mat-label>Choose Air Time Zone</mat-label>
                                <mat-select [(ngModel)]="activeWebinar.airTimeZoneId" required>
                                    <mat-option *ngFor="let timeZone of timeZoneList" [value]="timeZone.value">
                                        {{timeZone.name}}
                                    </mat-option>
                                </mat-select>
                                <mat-error [hidden]="this.valid">Air Time Zone is required</mat-error>
                            </mat-form-field>
                        </div>
                    </div>


                    <mat-form-field>
                        <mat-label>Choose Webinar Image</mat-label>
                        <mat-select [(ngModel)]="activeWebinar.thumbnailImage" required>
                            <mat-option *ngFor="let image of imageList" [value]="image.name">
                                <img style="width: 40px; margin-right: 10px;" [src]="'//ohi.net/' + image.name" />{{image.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Registration Link</mat-label>
                        <input matInput [(ngModel)]="activeWebinar.registrationLink" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Recorded Link</mat-label>
                        <input matInput [(ngModel)]="activeWebinar.recordedLink" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Description</mat-label>
                        <textarea matInput rows="10" style="line-height: 2em;" [(ngModel)]="activeWebinar.description"></textarea>
                    </mat-form-field>
                </div>
                <div class="card-footer">
                    <button class="btn btn-primary" (click)="addWebinar()">
                        <fa-icon [icon]="['fas', 'plus']"></fa-icon>Add New
                    </button>
                    <button class="btn btn-success" (click)="saveWebinar()" [disabled]="getHasErrors()" [ngClass]="{'error': getHasErrors()}"> 
                       <ng-container *ngIf="saving; then tplSaveing; else tplSaved"></ng-container>
                        <ng-template #tplSaved><fa-icon [icon]="['fas', 'save']"></fa-icon></ng-template> 
                        <ng-template #tplSaveing><fa-icon [icon]="['fas', 'spinner']" [spin]="true" size="lg"></fa-icon></ng-template>                                                                             
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>